<template>
  <div id="appRoot">
    <v-app id="inspire" class="app">
      <PageHeader />
      <RouterView />
      <PageFooter />
    </v-app>
  </div>
</template>
<script>
import AppEvents from "./event";
import { RouterView } from "vue-router";
import PageHeader from "./components/PageHeader.vue";
import PageFooter from "./components/PageFooter.vue";
import { loadScript } from "vue-plugin-load-script";
import Vue from "vue";
import _ from 'lodash';
export default {
  components: {
    PageHeader,
    PageFooter
  },
  data() {
    return {
      dialogMessage: true,
      delMessage: "",
      delDialog: false,
      delId: 0,
      rightDrawer: false,
      isConfirm: false,
      snackbar: {
        timeout : 5000,
        show: false,
        text: "",
        color: ""
      },
      appLoading: false
    }
  },
  computed: {
    showCustomerMessage() {
      return Vue.$cookies.get('showCustomerMessage');
    }
  },
  methods: {
    delConfirmed() {
      this.delDialog = false;
      this.$root.$emit('CONFIRMED_REMOVE_DATA', this.delId);
    }
  },
  created() {
    AppEvents.forEach(item => {
      this.$root.$on(item.name, item.callback);
    });
    window.getApp = this;
    // this.$root.$on('COMPONENT_LOADED', _.debounce(function () {
    //   Vue.nextTick(() => { loadScript(`/assets/jquery-1.12.1.min.js?v=${Math.random().toString(36).slice(2)}`); });
    //   Vue.nextTick(() => { loadScript(`/assets/jquery-migrate-1.4.1.min.js?v=${Math.random().toString(36).slice(2)}`); });
    //   Vue.nextTick(() => { loadScript(`/assets/common.js?v=${Math.random().toString(36).slice(2)}`); });
    //   Vue.nextTick(() => { loadScript(`/assets/count.js?v=${Math.random().toString(36).slice(2)}`); });
    //   Vue.nextTick(() => { loadScript(`/assets/company.do?v=${Math.random().toString(36).slice(2)}`); });
    //   Vue.nextTick(() => { loadScript(`/assets/home.js?v=${Math.random().toString(36).slice(2)}`); });
    // }, 500, {'leading': true, 'trailing': true}));
  },
};
</script>
